import { authRoles } from 'app/auth';
import TesztlapokTable from 'app/admin/tesztlapok/table/TesztlapokTable';
import TesztlapokEditForm from 'app/admin/tesztlapok/editform/TesztlapokEditForm';

export default [
	{
		path: '/tesztlapok/edit/:id',
		component: TesztlapokEditForm,
		auth: authRoles.szervezo
	},
	{
		path: '/tesztlapok/:sessionNameParam?',
		component: TesztlapokTable,
		auth: authRoles.szervezo
	}
];
